import o from "./highrise1320.mjs";
import r from "./highrise661.mjs";
var e = "[object AsyncFunction]", a = "[object Function]", c = "[object GeneratorFunction]", i = "[object Proxy]";
function g(n) {
  if (!r(n))
    return !1;
  var t = o(n);
  return t == a || t == c || t == e || t == i;
}
export {
  g as default
};
